import { useGtag } from "./useGtag.mjs";
export function useTrackEvent(eventName, eventParams) {
  const { gtag } = useGtag();
  gtag("event", eventName, eventParams);
}
